// COPIA da TMA#718 di CriGio @ 18f1ef07d0fe7bf6a63c2730ac049e52c705f67e: src/lib/burraco/useOrientamento.ts
import { useEffect, useState } from 'react';

export type Orientamento = 'verticale' | 'orizzontale';

const QUERY = '(orientation: portrait)';

const leggi = (): Orientamento => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'orizzontale';
  return window.matchMedia(QUERY).matches ? 'verticale' : 'orizzontale';
};

/**
 * L'orientamento dello schermo: il tavolo ha DUE disegni, il palco orizzontale 844 x 390 (L-2969) e il tavolo verticale a colonna. Senza `matchMedia`
 * (jsdom, un ambiente senza schermo) vale «orizzontale»: e il disegno che c'era prima e che i test conoscono.
 */
export function useOrientamento(): Orientamento {
  const [o, setO] = useState<Orientamento>(leggi);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(QUERY);
    const aggiorna = () => setO(mq.matches ? 'verticale' : 'orizzontale');
    aggiorna();
    mq.addEventListener('change', aggiorna);
    return () => mq.removeEventListener('change', aggiorna);
  }, []);
  return o;
}
